module.exports = __webpack_public_path__ + "img/trafficico.bbdd74a4.png";